/**
 * Extracted from sections/ns-card-carousel.liquid (inline <script> at line 206).
 * Config bridge: window.__nsCardCarouselSections, keyed by section id. The Liquid the block
 * needed (its section id plus the settings listed in the bridge) is now
 * handed over as data, so the logic can live in a cacheable, deferred
 * asset instead of being parsed and compiled during the HTML parse
 * (INP work on the PDP). Boots once per registered section id.
 */

(function () {
  var cfg = window.__nsCardCarouselSections = window.__nsCardCarouselSections || {};
  function boot(nsSectionId, nsSettings) {
            (function () {
              let ccarSwiper = null;

              function initCcarSwiper() {
                const root = document.getElementById(`shopify-section-${nsSectionId}`);
                if (!root) return;

                const swiperEl = root.querySelector('.ns-ccar__swiper');
                if (!swiperEl) return;
                if (typeof Swiper === 'undefined') return;

                if (ccarSwiper) {
                  ccarSwiper.destroy(true, true);
                  ccarSwiper = null;
                }

                const prevEl = root.querySelector('.ns-ccar__prev');
                const nextEl = root.querySelector('.ns-ccar__next');
                const paginationEl = root.querySelector('.ns-ccar__pagination');

                ccarSwiper = new Swiper(swiperEl, {
                  slidesPerView: nsSettings.cardsMobile,
                  slidesPerGroup: 1,
                  spaceBetween: 16,
                  speed: 600,
                  grabCursor: true,
                  loop: false,
                  watchOverflow: true,
                  navigation: prevEl && nextEl ? { nextEl: nextEl, prevEl: prevEl } : false,
                  pagination: paginationEl
                    ? {
                        el: paginationEl,
                        clickable: true,
                        type: 'bullets'
                      }
                    : false,
                  breakpoints: {
                    769: {
                      slidesPerView: nsSettings.cardsDesktop,
                      slidesPerGroup: 1,
                      spaceBetween: 16
                    }
                  }
                });
              }

              function waitForSwiper(callback) {
                if (typeof Swiper !== 'undefined') {
                  callback();
                  return;
                }
                const checkInterval = setInterval(() => {
                  if (typeof Swiper !== 'undefined') {
                    clearInterval(checkInterval);
                    callback();
                  }
                }, 50);
              }

              waitForSwiper(initCcarSwiper);

              if (typeof Shopify !== 'undefined' && Shopify.designMode) {
                document.addEventListener('shopify:section:load', function () {
                  initCcarSwiper();
                });
              }
            })();
        
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
